import { render } from "./NotFound.vue?vue&type=template&id=79b57eb4"
const script = {}

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__